"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderCustomHeader = void 0;

var _components = require("@lt/components");

var _ChevronCompactRight = _interopRequireDefault(require("@lt/components/icons-react/rebrand/ChevronCompactRight"));

var _subMonths = _interopRequireDefault(require("date-fns/subMonths"));

var _addMonths = _interopRequireDefault(require("date-fns/addMonths"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable react/display-name */
var renderCustomHeader = function renderCustomHeader(_ref) {
  var isMobile = _ref.isMobile,
      setStartCurrentMonth = _ref.setStartCurrentMonth;
  return function (_ref2) {
    var monthDate = _ref2.monthDate,
        customHeaderCount = _ref2.customHeaderCount,
        decreaseMonth = _ref2.decreaseMonth,
        increaseMonth = _ref2.increaseMonth;
    var previousBtnHidden = !isMobile && customHeaderCount === 1;
    var nextBtnHidden = !isMobile && customHeaderCount === 0;

    var handleDecreaseMonth = function handleDecreaseMonth() {
      decreaseMonth();
      setStartCurrentMonth(function (prevState) {
        return (0, _subMonths["default"])(prevState, 1);
      });
    };

    var handleIncreaseMonth = function handleIncreaseMonth() {
      increaseMonth();
      setStartCurrentMonth(function (prevState) {
        return (0, _addMonths["default"])(prevState, 1);
      });
    };

    return /*#__PURE__*/_react["default"].createElement(StyledHeaderContainer, null, /*#__PURE__*/_react["default"].createElement(StyledButton, {
      variant: 'functional',
      disabled: previousBtnHidden,
      onClick: handleDecreaseMonth
    }, /*#__PURE__*/_react["default"].createElement(StyledArrow, {
      $isRotated: true,
      $isHidden: previousBtnHidden,
      height: 24
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: "react-datepicker__current-month"
    }, monthDate.toLocaleString('ru', {
      month: 'long',
      year: 'numeric'
    }).slice(0, -3)), /*#__PURE__*/_react["default"].createElement(StyledButton, {
      variant: 'functional',
      disabled: nextBtnHidden,
      onClick: handleIncreaseMonth
    }, /*#__PURE__*/_react["default"].createElement(StyledArrow, {
      $isHidden: nextBtnHidden,
      height: 24
    })));
  };
};

exports.renderCustomHeader = renderCustomHeader;
var StyledButton = (0, _styledComponents["default"])(_components.ButtonTs).withConfig({
  displayName: "renderCustomHeader__StyledButton",
  componentId: "sc-1hfgwdr-0"
})(["padding:0 24px;"]);
var StyledArrow = (0, _styledComponents["default"])(_ChevronCompactRight["default"]).withConfig({
  displayName: "renderCustomHeader__StyledArrow",
  componentId: "sc-1hfgwdr-1"
})(["cursor:pointer;path{fill:", ";}", ""], function (_ref3) {
  var $isHidden = _ref3.$isHidden;
  return $isHidden ? 'transparent' : 'var(--grey1)';
}, function (_ref4) {
  var $isRotated = _ref4.$isRotated;
  return $isRotated && "transform: rotate(180deg);";
});

var StyledHeaderContainer = _styledComponents["default"].div.withConfig({
  displayName: "renderCustomHeader__StyledHeaderContainer",
  componentId: "sc-1hfgwdr-2"
})(["display:flex;justify-content:space-between;align-items:flex-start;"]);